import styled from 'styled-components';

export const Title = styled.span`
  color: #d73e51;
  font-size: 1rem;
  font-weight: 300;
`;
